import { useState, useEffect, useCallback } from 'react'
import axios from 'axios'

import { useAuth } from '@/contexts/AuthContext'

const autoeditorApi = axios.create({
  baseURL: 'https://api.autoeditor.video',
})

const getSubtitlePresets = async (email: string) => {
  if (!window.autoeditor_token) {
    const userCreationResponse = await autoeditorApi.request({
      url: '/api/organization/create-user',
      method: 'POST',
      data: {
        apiKey: import.meta.env.VITE_AUTOEDITOR_API_KEY,
        userId: email,
      },
    })

    const identifier = userCreationResponse.data
    const loginResponse = await autoeditorApi.request({
      url: '/api/auth/local',
      method: 'POST',
      data: {
        identifier,
        password: identifier,
      },
    })

    window.autoeditor_token = loginResponse.data.jwt
  }

  try {
    const response = await autoeditorApi.request({
      url: '/graphql',
      method: 'POST',
      data: {
        query: '{ mySubtitlePresets { id name preview preset editable default __typename } }',
      },
      headers: {
        Authorization: `Bearer ${window.autoeditor_token}`,
      },
    })
    return response.data.data.mySubtitlePresets
  } catch (error) {
    if (error.response.status === 401) {
      // If the token is invalid, we need to get a new one
      window.autoeditor_token = null
      return getSubtitlePresets(email)
    }

    return []
  }
}

export default function useSubtitlePresets() {
  const [loading, setLoading] = useState<boolean>(true)
  const [subtitlePresets, setSubtitlePresets] = useState<any[]>([])
  const { user } = useAuth()

  const initialize = useCallback(async () => {
    setLoading(true)
    try {
      const presets = await getSubtitlePresets(user.email)
      setSubtitlePresets(presets)
    } finally {
      setLoading(false)
    }
    setLoading(false)
  }, [user?.email])

  useEffect(() => {
    if (user?.email) {
      initialize()
    }
  }, [user?.email])

  return {
    data: subtitlePresets,
    loading,
  }
}
